import React from "react"
import { Flex, Form } from "antd"
import { useTranslation } from "react-i18next"
import WarningOutlinedWithBg from "ui/WarningOutlinedWithBg"
import { Title, Text } from "ui/Typography"
import { Modal } from "ui/Modal"
import PropTypes from "prop-types"
import { spacings } from "themes/variables"
import { useSelector } from "react-redux"
import OTPInput from "ui/Input/OTPInput"
import ActionButtons from "../ActionButtons"

const ConfirmAccountDeletionModal = ({ visible, onCancel, onConfirm, text, title, primaryColor, primaryLabel }) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const isBtnLoading = useSelector((state) => {
    const user = state?.user
    return Boolean(
      user?.updateGuideAccountStatus?.loading ||
        user?.deleteAccount?.loading ||
        user?.scheduleDeletion?.loading ||
        user?.cancelScheduledDeletion?.loading
    )
  })

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      centered
      title={
        <Flex justify="center">
          <WarningOutlinedWithBg />
        </Flex>
      }
      width={450}
    >
      <Flex vertical gap={spacings.S}>
        <Title level={3}>{title}</Title>
        <Text>{text}</Text>
        <Title level={5}>{t("settings.verification_code", "Verification Code")}</Title>
        <Form form={form} onFinish={onConfirm}>
          <Form.Item
            name="otp"
            rules={[
              {
                required: true,
                validator: (_, value) => {
                  if (!value || !Array.isArray(value) || value.some((digit) => !digit)) {
                    return Promise.reject(new Error(t("form_validation.otp_required", "Please enter the complete OTP")))
                  }
                  return Promise.resolve()
                }
              }
            ]}
          >
            <OTPInput length={5} type="numeric" autoFocus />
          </Form.Item>
          <ActionButtons
            wrapperClassName="mt-3xl"
            onSecondary={onCancel}
            primaryHtmlType="submit"
            primaryLabel={primaryLabel}
            secondaryDisabled={isBtnLoading}
            primaryDisabled={isBtnLoading}
            primaryLoading={isBtnLoading}
            primaryColor={primaryColor}
          />
        </Form>
      </Flex>
    </Modal>
  )
}

ConfirmAccountDeletionModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  text: PropTypes.string,
  title: PropTypes.string,
  primaryColor: PropTypes.string,
  primaryLabel: PropTypes.string
}

export default ConfirmAccountDeletionModal
